import SectionLabel from '../ui/SectionLabel';
import SectionTitle from '../ui/SectionTitle';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';

export default function PracticeSection() {
  const { language } = useAppContext();
  const t = LandingTrans[language];
  const [ref, visible] = useScrollReveal();

  return (
    <section
      ref={ref}
      className={`bg-cream py-16 md:py-30 px-6 md:px-20 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 max-w-6xl mx-auto">
        <div>
          <SectionLabel>{t.practiceLabel}</SectionLabel>
          <SectionTitle className="mt-4 mb-6">
            {t.practiceTitle}<em className="italic text-clay">{t.practiceTitleEm}</em>
          </SectionTitle>
          <p className="text-base font-sans font-light text-ink-mid mb-6 text-left">
            {t.practiceIntro}
          </p>
          <blockquote className="border-l-2 border-clay pl-6 mb-6">
            <p className="font-serif text-xl italic text-ink leading-relaxed">
              {t.practiceQuote}
            </p>
          </blockquote>

          <h3 className="font-serif text-3xl font-bold text-ink mb-4 mt-20">{t.whoFits}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-sand-dark">
            <div className="bg-warm-white p-6">
              <h4 className="font-sans font-medium text-ink mb-2 text-center">{t.newbiesBox}</h4>
              <p className="text-sm font-sans font-light text-ink-mid leading-relaxed">
                {t.newbiesText}
              </p>
            </div>
            <div className="bg-sand p-6">
              <h4 className="font-sans font-medium text-ink mb-2 text-center">{t.prosBox}</h4>
              <p className="text-sm font-sans font-light text-ink-mid leading-relaxed">
                {t.prosText}
              </p>
            </div>
          </div>
        </div>

        <div>
          <p className="text-[13px] font-sans font-medium uppercase tracking-wider text-clay mb-6">
            {t.structureLabel}
          </p>
          <ul className="space-y-3 text-sm font-sans font-light text-ink-mid">
            <li className="flex gap-2">
              <span className="text-clay">—</span>
              {t.warmupItem}
            </li>
            <li className="flex gap-2">
              <span className="text-clay">—</span>
              {t.mainItem}
            </li>
            <li className="flex gap-2">
              <span className="text-clay">—</span>
              {t.shavasanaItem}
            </li>
          </ul>

          <div className="mt-12 p-7 bg-cream rounded-sm border border-sand-dark">
            <p className="text-[13px] font-sans uppercase text-ink-light mb-2">{t.callUs}</p>
            <a href="tel:+972559116975" className="font-serif text-2xl md:text-[28px] font-medium text-clay hover:underline">
              +972 55 911 69 75
            </a>
            <p className="text-[13px] font-sans text-ink-light mt-1">{t.whatsappTelegram}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
